import {
  GET_CROSS_FILTER_DATA,
  GET_GROUPS_LIST_CROSS_FILTER,
  GET_PARTICIPANTS_GROUPS_LIST,
  GET_PARTICIPANTS_LIST,
  GET_PARTICIPANTS_LIST_CROSS_FILTER,
  GROUPS_BY_ALIAS_MAP,
  GROUPS_BY_NAME_MAP,
  GROUPS_FOR_HOMEPAGE,
  GROUPS_FOR_HOMEPAGE_CROSS_FILTER,
  PARTICIPANTS_BY_ALIAS_MAP,
  PARTICIPANTS_BY_NAME_MAP,
  PARTICIPANTS_FOR_HOMEPAGE,
  PARTICIPANTS_FOR_HOMEPAGE_CROSS_FILTER,
} from '@/store/getterTypes';
import {URL_QUERIES} from '@/const';

export default {
  [PARTICIPANTS_BY_ALIAS_MAP](state) {
    return Object.fromEntries(
        Object.entries(state.participantsById)
            .map(([_, participant]) => [participant.alias.toLowerCase(), participant]) || [],
    );
  },
  [PARTICIPANTS_BY_NAME_MAP](state) {
    return Object.fromEntries(
        Object.entries(state.participantsById)
            .map(([_, participant]) => [participant.name.toLowerCase(), participant]) || [],
    );
  },
  [GROUPS_BY_ALIAS_MAP](state) {
    return Object.fromEntries(
        state.participantGroups
            .map((group) => [group.alias.toLowerCase(), group]) || [],
    );
  },
  [GET_PARTICIPANTS_LIST](state) {
    return state.participantsList;
  },
  [GET_PARTICIPANTS_GROUPS_LIST](state) {
    return state.participantGroups;
  },
  [GET_PARTICIPANTS_LIST_CROSS_FILTER](state, getters) {
    const list = getters[GET_CROSS_FILTER_DATA]?.participants || [];
    return [...list]?.map((id) => state.participantsById[id]) || [];
  },
  [GET_GROUPS_LIST_CROSS_FILTER](state, getters) {
    const list = getters[GET_CROSS_FILTER_DATA]?.participant_groups || [];
    return [...list]?.map((id) => state.participantGroupsById[id]) || [];
  },
  [GROUPS_BY_NAME_MAP](state) {
    return Object.fromEntries(
        state.participantGroups
            .map((group) => [group.name.toLowerCase(), group]) || [],
    );
  },
  [GROUPS_FOR_HOMEPAGE](state) {
    const list = [];
    [...state.participantGroups].forEach((item) => {
      if (!item.is_displayable) return;

      const url = new URL(window.location.origin);
      url.searchParams.set(URL_QUERIES.participantGroup, item.alias.toLowerCase());

      list.push({
        id: item.id,
        name: item.name,
        url: url.href.replace(url.origin, ''),
        icon: item.image,
        weight: item.weight,
      });
    });
    return list.sort((a, b) => b.weight - a.weight);
  },
  [GROUPS_FOR_HOMEPAGE_CROSS_FILTER](state, getters) {
    const list = getters[GET_CROSS_FILTER_DATA]?.participant_groups || [];
    return [...list]
        .map((id) => {
          const item = state.participantGroupsById[id];
          if (!item || !item.is_displayable) return null;

          const url = new URL(window.location.origin);
          url.searchParams.set(URL_QUERIES.participantGroup, item.alias.toLowerCase());

          return {
            id: item.id,
            name: item.name,
            url: url.href.replace(url.origin, ''),
            icon: item.image,
            weight: item.weight,
          };
        })
        .filter(Boolean)
        .sort((a, b) => {
          if (a.weight > b.weight) return -1;
          if (a.weight < b.weight) return 1;
          return 0;
        });
  },
  [PARTICIPANTS_FOR_HOMEPAGE](state) {
    const list = [];
    [...state.participantsList].forEach((item) => {
      if (!item.is_displayable) return;

      const url = new URL(window.location.origin);
      url.searchParams.set(URL_QUERIES.PARTICIPANT, item.alias.toLowerCase());

      list.push({
        id: item.id,
        name: item.name,
        url: url.href.replace(url.origin, ''),
        icon: item.images,
      });
    });
    return list;
  },
  [PARTICIPANTS_FOR_HOMEPAGE_CROSS_FILTER](state, getters) {
    const list = getters[GET_CROSS_FILTER_DATA]?.participants || [];

    return [...list]
        .map((id) => {
          const item = state.participantsById[id];
          if (!item || !item.is_displayable) return null;
          const url = new URL(window.location.origin);
          url.searchParams.set(URL_QUERIES.PARTICIPANT, item.alias.toLowerCase());

          return {
            id: item.id,
            name: item.name,
            url: url.href.replace(url.origin, ''),
            icon: item.images,
          };
        })
        .filter(Boolean);
  },
};
